/**
 * Plotly, loaded from the CDN the way the Jinja page loaded it.
 *
 * NOT an npm dependency on purpose: plotly's bundle is larger than the rest
 * of this app put together, and exactly one screen uses it. The script tag
 * is the same version the page it replaces used, so the 3D scatter renders
 * identically; a failed load degrades to a message rather than a blank card.
 */
const SRC = 'https://cdn.plot.ly/plotly-2.32.0.min.js'

type PlotlyTrace = Record<string, unknown>
type PlotlyLayout = Record<string, unknown>
export type Plotly = {
  react: (el: HTMLElement | string, data: PlotlyTrace[], layout: PlotlyLayout,
          config?: Record<string, unknown>) => Promise<unknown>
  purge: (el: HTMLElement | string) => void
}

declare global {
  interface Window { Plotly?: Plotly }
}

let pending: Promise<Plotly> | null = null

export function loadPlotly(): Promise<Plotly> {
  if (window.Plotly) return Promise.resolve(window.Plotly)
  if (pending) return pending
  pending = new Promise<Plotly>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${SRC}"]`)
    const script = existing ?? document.createElement('script')
    script.addEventListener('load', () => {
      if (window.Plotly) resolve(window.Plotly)
      else reject(new Error('Plotly loaded but did not register'))
    })
    script.addEventListener('error', () => {
      pending = null   // a later attempt may succeed; do not cache the failure
      reject(new Error('Could not load the plotting library'))
    })
    if (!existing) {
      script.src = SRC
      script.async = true
      document.head.appendChild(script)
    }
  })
  return pending
}
